export enum CryptoTokens {
  USDC = 'usdc',
  USDT = 'usdt',
}
